<div class="battles-tab">
  @if (battles.isLoading()) {
    <p class="regular-14">{{ 'loading' | transloco }}</p>
  } @else if (!battles.value().length) {
    <p class="regular-14">{{ 'noResultsFound' | transloco }}</p>
  } @else {
    <div class="display-flex vertical gap-12">
      @for (battle of battles.value(); track battle.id) {
        <div class="battle-card">
          <div class="battle-header display-flex gap-12">
            <span class="semibold-14">#{{ battle.id }} &middot; {{ battle.status }} &middot; {{ battle.cap }} &middot; {{ battle.creatorUsername }} &middot; {{ battle.expiresAt | date }}</span>
            @if (battle.status === 'open') {
              <button type="button" class="warning-bar-btn" (click)="openCancel(battle)">{{ 'cardsAdminForceCancel' | transloco }}</button>
            }
          </div>
          @if (battle.stakes.length) {
            <div class="stakes-row display-flex gap-8 margin-top-12">
              @for (stake of battle.stakes; track stake.username) {
                <span class="stake-chip regular-14">{{ stake.username }}: {{ stake.cardName.en }} ({{ stake.value }})</span>
              }
            </div>
          }
        </div>
      }
    </div>
  }

  @if (showCancelModal()) {
    <app-modal
      [title]="'cardsAdminForceCancel' | transloco"
      [footerButtons]="cancelModalButtons"
      (closeEvent)="closeCancel()">
      @if (selectedBattle(); as battle) {
        <p class="regular-14">#{{ battle.id }} &middot; {{ battle.creatorUsername }} &middot; {{ battle.cap }}</p>
      }
    </app-modal>
  }
</div>
